import { Box, Grid, Typography, Card, FormControl, styled, Table, TableContainer, TableCell, TableRow, tableCellClasses, TableHead, TableBody } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import styles from './scMembers.module.scss';
import { CommonButton, CommonOutlinedButton, CustomCalendarTodayOutlinedIcon, CustomCheckbox, CustomDatePicker, CustomMenuItem, CustomRadioButton, CustomRequiredInputLabel, CustomSelect, CustomTextFeild, StyledDateContainer, formatAmount } from '../common/StyledComponents/StyledFields';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Pagination from '../common/pagination/pagination';
import constants from "../../config/constants.json";
import { apiRequest, catchErrorMessageHandler } from '../../infrastructure/backendService';
import apiPath from "../../config/apiPaths.json";
import ErrorPopup from '../common/ErrorPopup';
import toast, { Toaster } from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import { useReactToPrint } from 'react-to-print';

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    whiteSpace: "nowrap",
    textOrientation: "mixed",
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

interface ErrorMessageTypes {
  donationDateFrom: string;
  donationDateTo: string;
  searchCriteria: string;
  donationAmount: string;
}

interface Params {
  page: number;
  size: number;
  year?: string; // Optional property
  isContest?: boolean; // Optional property
}

interface PrintParams {
  print: boolean;
  year?: string; // Optional property
  isContest?: boolean; // Optional property
}

const ScmReportsComponent = () => {

  const scmFormFields = {
    donationDateFrom: "",
    donationDateTo: "",
    searchCriteria: ">=",
    donationAmount: "",
  };
  const [headers, setHeaders] = useState([]);
  const [rowsVoting, setRowsVoting] = useState([]);
  const [scmFormData, setScmFormData] = useState({ ...scmFormFields });
  const [isDateFromPickerOpen, setDateFromPickerOpen] = useState(false);
  const [isDateToPickerOpen, setDateToPickerOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('donation');
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({ ...scmFormFields });
  const [donationReportData, setDonationReportData] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalVotingRecords, setTotalVotingRecords] = useState<number>(0);
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const [showTableComponent, setShowTableComponent] = useState<boolean>(false);
  const [contestReportData, setContestReportData] = useState([]);
  const [submitButton, setSubmitButton] = useState<boolean>(true);
  const [exportDonationButtonLoading, setExportDonationButtonLoading] = useState(false);
  const [exportVotingButtonLoading, setExportVotingButtonLoading] = useState(false);
  const [exportElectionContestButtonLoading, setExportElectionContestButtonLoading] = useState(false);
  const [printDonationButtonLoading, setPrintDonationButtonLoading] = useState(false);
  const [printVotingButtonLoading, setPrintVotingButtonLoading] = useState(false);
  const [printElectionContestButtonLoading, setPrintElectionContestButtonLoading] = useState(false);
  const [triggerPrint, setTriggerPrint] = useState(false);
  const [votingTriggerPrint, setVotingTriggerPrint] = useState(false);
  const [contestTriggerPrint, setContestTriggerPrint] = useState(false);
  const [donationReportPrintData, setDonationReportPrintData] = useState([]);
  const [headersPrint, setHeadersPrint] = useState([]);
  const [rowsVotingPrint, setRowsVotingPrint] = useState([]);
  const [headersContestPrintData, setHeadersContestPrintData] = useState([]);
  const [rowsContestPrintData, setRowsContestPrintData] = useState([]);
  const componentRef = useRef<any>(null);
  const componentVotingRef = useRef<any>(null);
  const componentContestRef = useRef<any>(null);
  console.log(donationReportPrintData, "printttttttttdataaaaaaaaa")
  const searchCriteriaList = [
    {
      criteria: "=<",
    },
    {
      criteria: ">=",
    },
  ]

  const [pageSize, setPageSize] = useState<number>(20);
  const prevPageNumber = usePrevious(pageNumber);
  const PrintStyles = `
  @page {
       size: tabloid;
       margin: 24px;
     }  
     /* Set layout to Landscape */
     body {
       width: 100vw;
       position: absolute;
     }
   @media print {
     .printable {
       display: block !important;
     }
   }
 `;

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  useEffect(() => {
    // Check if previous values are not undefined to ensure this is not the first render
    // And then check if the current values differ from the previous ones
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      submitApiCall();
    }
  }, [pageNumber, prevPageNumber, pageSize]);

  const handleOptionChange = (option: any) => {
    setSelectedOption(option);
    setScmFormData(scmFormFields);
    setDonationReportData([]);
    setShowTableComponent(false);
    setSubmitButton(true);
  };

  useEffect(() => {
    setDateFromPickerOpen(false);
  }, [scmFormData.donationDateFrom]);

  useEffect(() => {
    setDateToPickerOpen(false);
  }, [scmFormData.donationDateTo]);

  const handleDateFromPickerClick = () => {
    setDateToPickerOpen(false);
    setDateFromPickerOpen(true);
  };

  const handleDateToPickerClick = () => {
    setDateFromPickerOpen(false);
    setDateToPickerOpen(true);
  };

  const handleSubmit = () => {
    submitApiCall();
  }

  const submitApiCall = () => {
    setSubmitButtonLoading(true);
    let apiEndpoint = "";
    let reqBody = {};
    let params: Params = {
      page: pageNumber - 1,
      size: 20,
    };

    if (selectedOption === "donation") {
      apiEndpoint = apiPath.scmReportDonationApi;
      reqBody = {
        fromDate: scmFormData.donationDateFrom,
        toDate: scmFormData.donationDateTo,
        greaterThanOrEqual: scmFormData.searchCriteria === ">=",
        amount: scmFormData.donationAmount
      };
    } else if (selectedOption === "volunteering") {
      reqBody = {
        fromDate: scmFormData.donationDateFrom,
        toDate: scmFormData.donationDateTo,
        searchCriteria: scmFormData.searchCriteria,
        amount: scmFormData.donationAmount
      };
      alert("volunteering");
    } else if (selectedOption === "voting") {
      apiEndpoint = apiPath.scmReportsVotingApi;
      params.year = scmFormData.donationDateFrom; // Add year to params for voting
    } else if (selectedOption === "contest") {
      apiEndpoint = apiPath.scmReportsVotingApi;
      params.year = scmFormData.donationDateFrom;
      params.isContest = true;
    }

    apiRequest({
      method: "POST",
      endpoint: apiEndpoint,
      includeToken: true,
      body: JSON.stringify(reqBody),
      params: params,
    })
      .then((res) => {
        setSubmitButtonLoading(false);
        setDonationReportData(res?.data?.content);
        setTotalRecords(res?.data?.totalElements);
        setShowTableComponent(true);
        setHeaders(res?.data?.scMembersEligibilityReportHeader);
        setRowsVoting(res?.data?.scMembersEligibilityReportList?.content);
        setTotalVotingRecords(res?.data?.scMembersEligibilityReportList?.totalElements);
        setContestReportData(res?.data?.scMembersEligibilityReportList?.content)
      })
      .catch((err) => {
        setSubmitButtonLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handlePrintBrowser = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `SCM_Donation_Report`,
    pageStyle: PrintStyles
  });

  const handleVotingPrintBrowser = useReactToPrint({
    content: () => componentVotingRef.current,
    documentTitle: `SCM_Voting_Report`,
    pageStyle: PrintStyles
  });

  const handleElectionPrintBrowser = useReactToPrint({
    content: () => componentContestRef.current,
    documentTitle: `SCM_Election_Contest_Report`,
    pageStyle: PrintStyles
  });

  const handlePrint = async () => {
    await printApiCall();
    setTriggerPrint(true);
  };

  const handleVotingPrint = async () => {
    await printApiCall();
    setVotingTriggerPrint(true);
  };

  const handleContestPrint = async () => {
    await printApiCall();
    setContestTriggerPrint(true);
  };

  useEffect(() => {
    if (contestTriggerPrint && headersContestPrintData?.length > 0 && rowsContestPrintData?.length > 0) {
      handleElectionPrintBrowser();
      setContestTriggerPrint(false);
    }
  }, [headersContestPrintData, rowsContestPrintData, contestTriggerPrint, handleElectionPrintBrowser])

  useEffect(() => {
    if (votingTriggerPrint && headersPrint?.length > 0 && rowsVotingPrint?.length > 0) {
      handleVotingPrintBrowser();
      setVotingTriggerPrint(false);
    }
  }, [headersPrint, rowsVotingPrint, votingTriggerPrint, handleVotingPrintBrowser])

  useEffect(() => {
    if (triggerPrint && donationReportPrintData?.length > 0) {
      handlePrintBrowser();
      setTriggerPrint(false);
    }
  }, [donationReportPrintData, triggerPrint, handlePrintBrowser])

  const printApiCall = () => {
    setPrintDonationButtonLoading(true);
    setPrintVotingButtonLoading(true);
    setPrintElectionContestButtonLoading(true);
    let apiEndpoint = "";
    let reqBody = {};
    let params: PrintParams = {
      print: true,
    };

    if (selectedOption === "donation") {
      apiEndpoint = apiPath.scmReportDonationApi;
      reqBody = {
        fromDate: scmFormData.donationDateFrom,
        toDate: scmFormData.donationDateTo,
        greaterThanOrEqual: scmFormData.searchCriteria === ">=",
        amount: scmFormData.donationAmount
      };
    }
    // else if (selectedOption === "volunteering") {
    //   reqBody = {
    //     fromDate: scmFormData.donationDateFrom,
    //     toDate: scmFormData.donationDateTo,
    //     searchCriteria: scmFormData.searchCriteria,
    //     amount: scmFormData.donationAmount
    //   };
    //   alert("volunteering");
    // }
    else if (selectedOption === "voting") {
      apiEndpoint = apiPath.scmReportsVotingApi;
      params.year = scmFormData.donationDateFrom; // Add year to params for voting
    } else if (selectedOption === "contest") {
      apiEndpoint = apiPath.scmReportsVotingApi;
      params.year = scmFormData.donationDateFrom;
      params.isContest = true;
    }

    apiRequest({
      method: "POST",
      endpoint: apiEndpoint,
      includeToken: true,
      body: JSON.stringify(reqBody),
      params: params,
    })
      .then((res) => {
        setDonationReportPrintData(res?.data?.content);
        setPrintDonationButtonLoading(false);
        setPrintVotingButtonLoading(false);
        setPrintElectionContestButtonLoading(false);
        // setTotalRecords(res?.data?.totalElements);
        // setShowTableComponent(true);
        setHeadersPrint(res?.data?.scMembersEligibilityReportHeader);
        setRowsVotingPrint(res?.data?.scMembersEligibilityReportList?.content);
        setHeadersContestPrintData(res?.data?.scMembersEligibilityReportHeader);
        setRowsContestPrintData(res?.data?.scMembersEligibilityReportList?.content);
        // setTotalVotingRecords(res?.data?.scMembersEligibilityReportList?.totalElements);
        // setContestReportData(res?.data?.scMembersEligibilityReportList?.content)
      })
      .catch((err) => {
        setPrintDonationButtonLoading(false);
        setPrintVotingButtonLoading(false);
        setPrintElectionContestButtonLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleExportToExcel = () => {
    ExportToExcelApi();
  }

  const ExportToExcelApi = async () => {
    setExportDonationButtonLoading(true);
    setExportVotingButtonLoading(true);
    setExportElectionContestButtonLoading(true); // Set loading to true when the export starts

    let apiEndpoint = "";
    let reqBody = {};
    let params: Params = {
      page: pageNumber - 1,
      size: 20,
    };

    if (selectedOption === "donation") {
      apiEndpoint = "/temple-management/scm-donation-report/excel";
      reqBody = {
        fromDate: scmFormData.donationDateFrom,
        toDate: scmFormData.donationDateTo,
        greaterThanOrEqual: scmFormData.searchCriteria === ">=",
        amount: scmFormData.donationAmount
      };
    } else if (selectedOption === "voting") {
      apiEndpoint = "/temple-management/scm-voting-eligibility-report/excel";
      params.year = scmFormData.donationDateFrom;
    } else if (selectedOption === "contest") {
      apiEndpoint = "/temple-management/scm-voting-eligibility-report/excel";
      params.year = scmFormData.donationDateFrom;
      params.isContest = true;
    }

    try {
      const response = await apiRequest({
        method: "POST",
        endpoint: apiEndpoint,
        body: JSON.stringify(reqBody),
        includeToken: true,
        responseType: "arraybuffer",
        params: params,
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      if (selectedOption === "donation") {
        link.download = "SCM Donation Report.xlsx";
      } else if (selectedOption === "voting") {
        link.download = "SCM Voting Report.xlsx";
      } else {
        link.download = "SCM Election Contest Report.xlsx";
      }
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    } finally {
      setExportDonationButtonLoading(false);
      setExportVotingButtonLoading(false);
      setExportElectionContestButtonLoading(false); // Ensure loading state is reset after the operation
    }
  };

  const handleCancel = () => {
    setScmFormData(scmFormFields)
  }

  const handleFieldChange = (field: string, value: any) => {
    if (selectedOption === "donation") {
      if (scmFormData.donationDateFrom && scmFormData.donationDateTo && scmFormData.donationAmount != null) {
        setSubmitButton(false);
      } else {
        setSubmitButton(true);
      }
    } else if (selectedOption === "voting") {
      if (scmFormData.donationDateFrom != null) {
        setSubmitButton(false);
      } else {
        setSubmitButton(true);
      }
    } else if (selectedOption === "contest") {
      if (scmFormData.donationDateFrom != null) {
        setSubmitButton(false);
      } else {
        setSubmitButton(true);
      }
    }
    if (field === "donationDateFrom" || field === "donationDateTo") {
      const formattedDate = dayjs(value, "YYYY-MM-DD");
      setDateFromPickerOpen(false);
      setDateToPickerOpen(false);

      setScmFormData({
        ...scmFormData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("YYYY-MM-DD")
          : "",
      });
    } else {
      setScmFormData({
        ...scmFormData,
        [field]: value,
      });
    }
    setDateFromPickerOpen(false);
    setDateToPickerOpen(false);
  };

  const donationDatePickerFrom = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer id="dob"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
        // onClick={handleDateFromPickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDateFromPickerOpen}
                onClose={() => handleDateFromPickerClick}
                slots={{
                  openPickerIcon: () => (
                    <div onClick={handleDateFromPickerClick}>
                      <CustomCalendarTodayOutlinedIcon />
                    </div>
                  ),
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  scmFormData.donationDateFrom
                    ? dayjs(scmFormData.donationDateFrom, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, donationDateFrom: "" });
                  handleFieldChange("donationDateFrom", value);
                  setDateFromPickerOpen(false);
                }}
                disableFuture
                className={
                  errorMessage.donationDateFrom
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.donationDateFrom ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.donationDateFrom}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const donationDatePickerTo = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer id="dob"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
        // onClick={handleDateToPickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDateToPickerOpen}
                onClose={() => setDateToPickerOpen(false)}
                slots={{
                  openPickerIcon: () => (
                    <div onClick={handleDateToPickerClick}>
                      <CustomCalendarTodayOutlinedIcon />
                    </div>
                  ),
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  scmFormData.donationDateTo
                    ? dayjs(scmFormData.donationDateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, donationDateTo: "" });
                  handleFieldChange("donationDateTo", value);
                  setDateToPickerOpen(false);
                }}
                disableFuture
                className={
                  errorMessage.donationDateTo
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.donationDateTo ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.donationDateTo}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const searchCriteriaDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.donationDropdownMainContainer}>
        <CustomSelect
          defaultValue=""
          value={scmFormData.searchCriteria}
          id="purposeOfDonations"
          IconComponent={KeyboardArrowDownIcon}
          onChange={(e) => {
            setErrorMessage({ ...errorMessage, searchCriteria: "" });
            handleFieldChange("searchCriteria", e.target.value);
          }}
          className={styles.textField}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {searchCriteriaList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.criteria}>
              {item.criteria}
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const scmReportsByDonationFields = () => {
    return (
      <Box>
        <Grid>
          <Grid container spacing={2} sx={{ marginLeft: "0" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Search By Donation Date From", false)}
              {donationDatePickerFrom()}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Search By Donation Date To", false)}
              {donationDatePickerTo()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0", marginLeft: "0" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Search Criteria", false)}
              {searchCriteriaDropdown()}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Amount", true)}
              <CustomTextFeild
                fullWidth
                required
                value={scmFormData.donationAmount}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^\d.]/g, '');

                  // Prevent zero as the first character unless it's the only character
                  if (value.length > 1 && value[0] === '0') {
                    value = value.slice(1);
                  }

                  // Limit to 10 characters
                  const numericValue = value.slice(0, 10);

                  handleFieldChange("donationAmount", numericValue);
                  setErrorMessage({ ...errorMessage, donationAmount: "" });
                }}
                className={
                  errorMessage.donationAmount
                    ? styles.errorTextField
                    : styles.textField
                }
                placeholder="Enter Amount"
              />

              {errorMessage.donationAmount && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.donationAmount}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )
  }

  const scmReportsByVolunteeringFields = () => {
    return (
      <Box>
        <Grid>
          <Grid container spacing={2} sx={{ marginLeft: "0" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Volunteering Period Start Date", false)}
              {donationDatePickerFrom()}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Volunteering Period End Date", false)}
              {donationDatePickerTo()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0", marginLeft: "0" }}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Search Criteria", false)}
              {searchCriteriaDropdown()}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )
  }

  const scmReportsByVotingEligibilityFields = () => {
    return (
      <Box>
        <Grid container spacing={2} sx={{ marginLeft: "0" }}>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("As of Today", false)}
            {donationDatePickerFrom()}
          </Grid>
        </Grid>
      </Box>
    )
  }

  const scmReportsByContestInElectionFields = () => {
    return (
      <Box>
        <Grid container spacing={2} sx={{ marginLeft: "0" }}>
          <Grid xs={12} sm={4} item>
            {CustomRequiredInputLabel("As of Today", false)}
            {donationDatePickerFrom()}
          </Grid>
        </Grid>
      </Box>
    )
  }

  const PrintListItemTable = () => {
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} ref={componentRef} id="generatedTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                <StyledTableCell className={styles.tableHorizontal}>Sign In name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal} style={{ textAlign: "right" }}>Donation Amount</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal} style={{ textAlign: "right" }}>Refund Amount</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Address</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Home Phone</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Work Phone</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Email</StyledTableCell>

              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {donationReportPrintData?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.username}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstName} ${row.middleName ? row.middleName + ' ' : ''} ${row.lastName}`}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "right",
                    }}
                  >
                    {formatAmount(row.amount)}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "right",
                    }}
                  >
                    {formatAmount(row.refundAmount)}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.homePhone === null || row.homePhone === "" ? "-" : row.homePhone}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.workPhone === null || row.workPhone === "" ? "-" : row.workPhone}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </>
    );
  };

  const listItemTable = () => {
    if (donationReportData?.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} id="generatedTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                <StyledTableCell className={styles.tableHorizontal}>Sign In name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Name</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal} style={{ textAlign: "right" }}>Donation Amount</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal} style={{ textAlign: "right" }}>Refund Amount</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Address</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Home Phone</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Work Phone</StyledTableCell>
                <StyledTableCell className={styles.tableHorizontal}>Email</StyledTableCell>

              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {donationReportData?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.username}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {`${row.firstName} ${row.middleName ? row.middleName + ' ' : ''} ${row.lastName}`}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "right",
                    }}
                  >
                    {formatAmount(row.amount)}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "right",
                    }}
                  >
                    {formatAmount(row.refundAmount)}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.homePhone === null || row.homePhone === "" ? "-" : row.homePhone}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.workPhone === null || row.workPhone === "" ? "-" : row.workPhone}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
        {totalRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const printVotingListItemTable = () => {
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} ref={componentVotingRef} id="generatedVotingTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                {headersPrint?.map((header: any, index: number) => (
                  <StyledTableCell key={index} className={styles.tableHorizontal}>
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {rowsVotingPrint?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  // onClick={() => handleSignInNameClick(row)}
                  >
                    {row.firstName === null || row.firstName === "" ? "-" : row.firstName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.lastName === null || row.lastName === "" ? "-" : row.lastName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.userName === null || row.userName === "" ? "-" : row.userName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.scStatus === null || row.scStatus === "" ? "-" : row.scStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.nextYearSCStatus === null || row.nextYearSCStatus === "" ? "-" : row.nextYearSCStatus}
                  </StyledTableCell>
                  {row.quarterAttendance.map((item: any, i: number) => (
                    <StyledTableCell key={i} className={styles.tableHorizontal}>
                      {item.attended ? "Yes" : "No"}
                    </StyledTableCell>

                  ))}
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.city === null || row.city === "" ? "-" : row.city}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.country === null || row.country === "" ? "-" : row.country}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.state === null || row.state === "" ? "-" : row.state}
                  </StyledTableCell>

                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.zipCode === null || row.zipCode === "" ? "-" : row.zipCode}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneResidence === null || row.phoneResidence === "" ? "-" : row.phoneResidence}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork === null || row.phoneWork === "" ? "-" : row.phoneWork}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </>
    );
  };

  const votingListItemTable = () => {
    if (rowsVoting?.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} id="generatedVotingTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                {headers?.map((header: any, index: number) => (
                  <StyledTableCell key={index} className={styles.tableHorizontal}>
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {rowsVoting?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  // onClick={() => handleSignInNameClick(row)}
                  >
                    {row.firstName === null || row.firstName === "" ? "-" : row.firstName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.lastName === null || row.lastName === "" ? "-" : row.lastName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.userName === null || row.userName === "" ? "-" : row.userName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.scStatus === null || row.scStatus === "" ? "-" : row.scStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.nextYearSCStatus === null || row.nextYearSCStatus === "" ? "-" : row.nextYearSCStatus}
                  </StyledTableCell>
                  {row.quarterAttendance.map((item: any, i: number) => (
                    <StyledTableCell key={i} className={styles.tableHorizontal}>
                      {item.attended ? "Yes" : "No"}
                    </StyledTableCell>

                  ))}
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.city === null || row.city === "" ? "-" : row.city}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.country === null || row.country === "" ? "-" : row.country}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.state === null || row.state === "" ? "-" : row.state}
                  </StyledTableCell>

                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.zipCode === null || row.zipCode === "" ? "-" : row.zipCode}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneResidence === null || row.phoneResidence === "" ? "-" : row.phoneResidence}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork === null || row.phoneWork === "" ? "-" : row.phoneWork}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
        {totalVotingRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalVotingRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const printContestListItemTable = () => {
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} ref={componentContestRef} id="generatedElectionContestTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                {headersContestPrintData?.map((header: any, index: number) => (
                  <StyledTableCell key={index} className={styles.tableHorizontal}>
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {rowsContestPrintData?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  // onClick={() => handleSignInNameClick(row)}
                  >
                    {row.firstName === null || row.firstName === "" ? "-" : row.firstName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.lastName === null || row.lastName === "" ? "-" : row.lastName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.userName === null || row.userName === "" ? "-" : row.userName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.scStatus === null || row.scStatus === "" ? "-" : row.scStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.nextYearSCStatus === null || row.nextYearSCStatus === "" ? "-" : row.nextYearSCStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.eligibleForEC === true ? "Yes" : "No"}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.eligibleForBOD === true ? "Yes" : "No"}
                  </StyledTableCell>
                  {row.quarterAttendance.map((item: any, i: number) => (
                    <StyledTableCell key={i} className={styles.tableHorizontal}>
                      {item.attended ? "Yes" : "No"}
                    </StyledTableCell>

                  ))}
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.city === null || row.city === "" ? "-" : row.city}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.country === null || row.country === "" ? "-" : row.country}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.state === null || row.state === "" ? "-" : row.state}
                  </StyledTableCell>

                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.zipCode === null || row.zipCode === "" ? "-" : row.zipCode}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneResidence === null || row.phoneResidence === "" ? "-" : row.phoneResidence}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork === null || row.phoneWork === "" ? "-" : row.phoneWork}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
      </>
    );
  };

  const contestListItemTable = () => {
    if (contestReportData?.length === 0) {
      return <Typography sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}><b>{constants.NO_RECORDS_FOUND}</b></Typography>;
    }
    return (
      <>
        <StyledTableContainer style={{ overflowY: "auto" }} id="generatedElectionContestTable">
          <StyledTable className={styles.tableContainer}>
            <TableHead>
              <TableRow className={styles.headerTableRow}>
                {headers?.map((header: any, index: number) => (
                  <StyledTableCell key={index} className={styles.tableHorizontal}>
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody} id="searchScmData">
              {rowsVoting?.map((row: any, id: number) => (
                <StyledTableRow key={id} className={styles.tableRow}>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  // onClick={() => handleSignInNameClick(row)}
                  >
                    {row.firstName === null || row.firstName === "" ? "-" : row.firstName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.lastName === null || row.lastName === "" ? "-" : row.lastName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.userName === null || row.userName === "" ? "-" : row.userName}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.scStatus === null || row.scStatus === "" ? "-" : row.scStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.nextYearSCStatus === null || row.nextYearSCStatus === "" ? "-" : row.nextYearSCStatus}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.eligibleForEC === true ? "Yes" : "No"}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    {row.eligibleForBOD === true ? "Yes" : "No"}
                  </StyledTableCell>
                  {row.quarterAttendance.map((item: any, i: number) => (
                    <StyledTableCell key={i} className={styles.tableHorizontal}>
                      {item.attended ? "Yes" : "No"}
                    </StyledTableCell>

                  ))}
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.address === null || row.address === "" ? "-" : row.address}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.city === null || row.city === "" ? "-" : row.city}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.country === null || row.country === "" ? "-" : row.country}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.state === null || row.state === "" ? "-" : row.state}
                  </StyledTableCell>

                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.zipCode === null || row.zipCode === "" ? "-" : row.zipCode}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneResidence === null || row.phoneResidence === "" ? "-" : row.phoneResidence}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.phoneWork === null || row.phoneWork === "" ? "-" : row.phoneWork}
                  </StyledTableCell>
                  <StyledTableCell
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "start",
                    }}
                  >
                    {row.email === null || row.email === "" ? "-" : row.email}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </StyledTable>
        </StyledTableContainer>
        {totalVotingRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalVotingRecords}
              itemsPerPage={20}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  // function formatNumber(donationAmount:any) {
  //   return donationAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // }

  function formatNumberToIndian(amount: any) {
    const x = amount.toString().split('.');
    let lastThree = x[0].substring(x[0].length - 3);
    const otherNumbers = x[0].substring(0, x[0].length - 3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
    const formattedNumber = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return x.length > 1 ? formattedNumber + '.' + x[1] : formattedNumber;
  }

  return (
    <Box>
      <Card className={styles.cardContainer}>
        <Grid className={styles.radioButtons}>
          <Grid className={styles.radioButtonsLabel}>
            <CustomRadioButton
              checked={selectedOption === 'donation'}
              onChange={() => handleOptionChange('donation')}
            />
            <label className={`${styles.tab} ${selectedOption === "donation" ? `${styles.active}` : ''}`}>SCM Report By Donation</label>
          </Grid>
          {/* <Grid className={styles.radioButtonsLabel}>
            <CustomRadioButton
              checked={selectedOption === 'volunteering'}
              onChange={() => handleOptionChange('volunteering')}
            />
            <label className={`${styles.tab} ${selectedOption === "volunteering" ? `${styles.active}` : ''}`}>SCM Report By Volunteering</label>
          </Grid> */}
          <Grid className={styles.radioButtonsLabel}>
            <CustomRadioButton
              checked={selectedOption === 'voting'}
              onChange={() => handleOptionChange('voting')}
            />
            <label className={`${styles.tab} ${selectedOption === "voting" ? `${styles.active}` : ''}`}>SCM Report Voting Eligibility</label>
          </Grid>
          <Grid className={styles.radioButtonsLabel}>
            <CustomRadioButton
              checked={selectedOption === 'contest'}
              onChange={() => handleOptionChange('contest')}
            />
            <label className={`${styles.tab} ${selectedOption === "contest" ? `${styles.active}` : ''}`}>SCM Report Election Eligibility</label>
          </Grid>
        </Grid>
      </Card>
      <Card className={styles.cardContainer}>
        {selectedOption === 'donation' && scmReportsByDonationFields()}
        {/* {selectedOption === 'volunteering' && scmReportsByVolunteeringFields()} */}
        {selectedOption === 'voting' && scmReportsByVotingEligibilityFields()}
        {selectedOption === 'contest' && scmReportsByContestInElectionFields()}
      </Card>
      <Grid sx={{ margin: "10px 0px", display: "flex", gap: "10px" }}>
        <CommonButton
          onClick={handleSubmit}
          id="submit"
          type="submit"
          disabled={submitButton}
        >
          {submitButtonLoading ? (
            <>
              <ClipLoader color="#fff" loading={submitButtonLoading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleCancel}>Cancel</CommonOutlinedButton>
      </Grid>
      {selectedOption === 'donation' && showTableComponent &&
        <Grid sx={{ marginTop: "10px" }}>
          {donationReportData.length != 0 &&
            <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
              <Grid sx={{ display: "flex", gap: "5px" }}>
                <Typography sx={{ fontWeight: 700 }}>Start Date: {scmFormData.donationDateFrom}</Typography>
                <Typography sx={{ fontWeight: 700 }}>End Date: {scmFormData.donationDateTo}</Typography>
              </Grid>
              <Grid>
                <Typography sx={{ fontWeight: 700 }}>Search Criteria and Amount: {scmFormData.searchCriteria} ${formatNumberToIndian(scmFormData.donationAmount)}</Typography>
              </Grid>
            </Grid>}
          <Grid sx={{ display: "flex", gap: "10px", float: "right" }}>
            {/* <CommonOutlinedButton onClick={handleExportToExcel}>Export to excel</CommonOutlinedButton> */}
            <CommonButton
              onClick={handleExportToExcel}
              id="exportDonation"
              type="submit"
            >
              {exportDonationButtonLoading ? (
                <>
                  <ClipLoader color="#fff" loading={exportDonationButtonLoading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Export to excel"
              )}
            </CommonButton>
            {/* <CommonButton onClick={handlePrint}>Print</CommonButton> */}
            <CommonButton
              onClick={handlePrint}
              id="printDonation"
              type="submit"
            >
              {printDonationButtonLoading ? (
                <>
                  <ClipLoader color="#fff" loading={printDonationButtonLoading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Print"
              )}
            </CommonButton>
          </Grid>
          {selectedOption === 'donation' && <div className="no_print">{listItemTable()}</div>}
          {selectedOption === 'donation' && <div className='printable' style={{ display: "none" }}>
            {PrintListItemTable()}
          </div>
          }
        </Grid>
      }
      <Grid sx={{ marginTop: "10px" }}>
        {selectedOption === 'voting' && showTableComponent &&
          <Grid>
            <Grid sx={{ display: "flex", gap: "10px", float: "right" }}>
              {/* <CommonOutlinedButton onClick={handleExportToExcel}>Export to excel</CommonOutlinedButton> */}
              <CommonButton
                onClick={handleExportToExcel}
                id="exportVoting"
                type="submit"
              >
                {exportVotingButtonLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={exportVotingButtonLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  "Export to excel"
                )}
              </CommonButton>
              {/* <CommonButton onClick={handleVotingPrintBrowser}>Print</CommonButton> */}
              <CommonButton
                onClick={handleVotingPrint}
                id="printVoting"
                type="submit"
              >
                {printVotingButtonLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={printVotingButtonLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  "Print"
                )}
              </CommonButton>
            </Grid>
            <Grid>
              {selectedOption === 'voting' && <div className="no_print">{votingListItemTable()}</div>}
              {selectedOption === 'voting' && <div className='printable' style={{ display: "none" }}>
                {printVotingListItemTable()}
              </div>
              }
              {/* {votingListItemTable()} */}
            </Grid>
          </Grid>
        }
      </Grid>
      <Grid sx={{ marginTop: "10px" }}>
        {selectedOption === 'contest' && showTableComponent &&
          <Grid>
            <Grid sx={{ display: "flex", gap: "10px", float: "right" }}>
              {/* <CommonOutlinedButton onClick={handleExportToExcel}>Export to excel</CommonOutlinedButton> */}
              <CommonButton
                onClick={handleExportToExcel}
                id="exportContest"
                type="submit"
              >
                {exportElectionContestButtonLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={exportElectionContestButtonLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  "Export to excel"
                )}
              </CommonButton>
              {/* <CommonButton onClick={handleElectionPrintBrowser}>Print</CommonButton> */}
              <CommonButton
                onClick={handleContestPrint}
                id="printContest"
                type="submit"
              >
                {printElectionContestButtonLoading ? (
                  <>
                    <ClipLoader color="#fff" loading={printElectionContestButtonLoading} size={15} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      Loading...
                    </span>
                  </>
                ) : (
                  "Print"
                )}
              </CommonButton>
            </Grid>
            <Grid>
              {selectedOption === 'contest' && <div className="no_print">{contestListItemTable()}</div>}
              {selectedOption === 'contest' && <div className='printable' style={{ display: "none" }}>
                {printContestListItemTable()}
              </div>
              }
              {/* {contestListItemTable()} */}
            </Grid>
          </Grid>
        }
      </Grid>
    </Box>
  )
}

export default ScmReportsComponent